<div class="animated fadeIn">
  <div class="row">
    <div class="col-lg-12">
      <div class="card mt-4">
        <div class="card-header">
          <i class="fas fas-align-justify"></i>
          Remedial
        </div>
        <div class="card-body">
          <h4>Remedial Details</h4>
          <div [formGroup]="remedialForm">
            <div class="row">
              <div class="col-6">
                <label class="col-form-label d-block text-center">
                  Please select an account
                  <ng-select
                    [items]="customers"
                    bindLabel="companyName"
                    [appearance]="'outline'"
                    [(ngModel)]="selectedCustomer"
                    [ngModelOptions]="{standalone: true}"
                    [compareWith]="compareCustomers"
                    (change)="selectCustomer($event)"
                  >
                  </ng-select>
                </label>
              </div>
              <div class="col-6">
                <label class="col-form-label d-block">
                  Search for plot
                  <ng-select [items]="quotes | async"
                             [typeahead]="quoteSearchInput"
                             (change)="selectQuote($event)"
                             [minTermLength]="1"
                             [(ngModel)]="selectedQuote"
                             [ngModelOptions]="{standalone: true}"
                             [compareWith]="compareQuotes"
                             placeholder="Search for plot">
                    <ng-template ng-label-tmp let-item="item">
                      <span>{{ displayQuote(item) }}</span>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
                      <span>{{ displayQuote(item) }}</span>
                    </ng-template>
                  </ng-select>
                </label>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-4">
                <labeled-input
                  [name]="'Name'"
                  [formName]="'name'"
                  [form]="remedialForm"
                  [type]="'text'"
                  [required]="true"
                  [class]="'form-control'"></labeled-input>
              </div>
              <div class="col-4">
                <labeled-input
                  [name]="'Park'"
                  [formName]="'park'"
                  [form]="remedialForm"
                  [type]="'text'"
                  [required]="true"
                  [class]="'form-control'"></labeled-input>
              </div>
              <div class="col-4">
                <labeled-input
                  [name]="'Plot'"
                  [formName]="'plot'"
                  [form]="remedialForm"
                  [type]="'text'"
                  [required]="true"
                  [class]="'form-control'"></labeled-input>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <labeled-input
                  [name]="'Contract Number'"
                  [formName]="'contractNumber'"
                  [form]="remedialForm"
                  [type]="'text'"
                  [class]="'form-control'"></labeled-input>
              </div>
              <div class="col-4">
                <labeled-input
                  [name]="'Serial Number'"
                  [formName]="'serialNumber'"
                  [form]="remedialForm"
                  [type]="'text'"
                  [required]="true"
                  [class]="'form-control'"></labeled-input>
              </div>
              <div class="col-4">
                <label>Installation Date</label>
                <div class="input-group">
                  <input
                    class="form-control"
                    formControlName="installationDate"
                    ngbDatepicker
                    #d="ngbDatepicker"
                    placeholder="YYYY-MM-DD"
                    [ngModel]="installationDateStruct"
                    (dateSelect)="onDateSelect($event)"
                    (click)="d.toggle()"
                    navigation="select"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-8">
                <label class="col-form-label d-block">
                  Description*
                  <textarea
                    class="form-control"
                    formControlName="description"
                    rows="5"
                    required>
</textarea>
                  <div *ngIf="isInvalid(descriptionCtrl)" class="mt-1 text-danger">
                    <div *ngIf="hasError(descriptionCtrl, 'required')">
                      Description is required.
                    </div>
                  </div>
                </label>
              </div>
            </div>
            <hr>
            <h4 class="mt-3">Remedial Rows</h4>
            <div class="row">
              <div class="card-body">
                <form [formGroup]="remedialRowsForm">
                  <div formArrayName="rows">
                    <table class="table table-striped table-bordered">
                      <thead>
                      <tr>
                        <th>Item</th>
                        <th>Issue</th>
                        <th>Description (Optional)</th>
                        <td>Main Issue</td>
                        <td></td>
                      </tr>
                      </thead>
                      <tbody>
                      <tr *ngFor="let item of rowItems; index as i" [formGroupName]="i">
                        <td class="col-2">
                          <ng-select [items]="remedialItems" [multiple]="false"
                                     formControlName="item"
                                     bindLabel="details"
                                     [required]="true"
                                     bindValue="details">
                          </ng-select>
                          <div *ngIf="isInvalid(item.get('item'))">
                            <small class="text-danger">Item is required.</small>
                          </div>
                        </td>
                        <td class="col-2">
                          <ng-select [items]="remedialLocations" [multiple]="false"
                                     formControlName="issue"
                                     [required]="true"
                                     bindLabel="details"
                                     bindValue="details">
                          </ng-select>
                          <div *ngIf="isInvalid(item.get('issue'))">
                            <small class="text-danger">Issue is required.</small>
                          </div>
                        </td>
                        <td><input type="text" [formControlName]="'description'" class="form-control"/></td>
                        <td class="col-1">
                          <div class="form-check">
                            <input class="form-check-input" type="radio" name="radio" id="radio{{i}}"
                                   (click)="setMainIssue(i)">
                          </div>
                        </td>
                        <td class="col-1 text-center">
                          <button class="btn btn-danger" (click)="removeRow(i)">Remove</button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <div *ngIf="hasError(rows, 'minRows') && isInteracted(rows)">
                      At least {{ rows.errors?.['minRows']?.required }} rows are required.
                    </div>
                    <div *ngIf="rowCheck">
                      <p class="text-danger">Please add at least one row.</p>
                    </div>
                    <button type="button" (click)="addRow()" class="btn btn-primary">Add Row</button>
                  </div>
                  <hr>
                </form>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <h4 class="float-left">Remedial Images</h4>
                <button (click)="this.uploadImages()" type="button" class="float-right mt-2 mb-2 btn btn-primary">Upload
                  Pictures
                </button>
                <button (click)="this.showWebcam()" type="button" class="float-right m-3 btn btn-info">Take
                  Picture
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="row justify-content-center" *ngIf="showDocUpload">
                  <div class="col-auto">
                    <ngx-dropzone (change)="onSelect($event)" accept="image/jpeg,image/jpg,image/png"
                                  [maxFileSize]="10000000">
                      <ngx-dropzone-label>Drag N Drop or click to select!</ngx-dropzone-label>
                      <ngx-dropzone-image-preview *ngFor="let f of files" [removable]="true" (removed)="onRemove(f)"
                                                  [file]="f">
                        <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                      </ngx-dropzone-image-preview>
                    </ngx-dropzone>
                  </div>
                </div>
                <remedial-images [showCamera]="showCamera"></remedial-images>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col">
                <button (click)="this.submitForm()" type="button" class="float-right mt-2 mb-2 btn btn-primary">Create
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <swal
    #createTraceRequestSwal
    title="Trace Request"
    [showCancelButton]="true"
    [customClass]="{ htmlContainer: 'overflow-initial' }"
    text="Are you sure?"
    confirmButtonText="Yes"
    (confirm)="sendTraceRequest($event)">
  </swal>

</div>
